<template>
  <page-header-wrapper>
    <a-card>
      <div class="flex align-center">
        <div class="abox" :class="{ active: activeIndex === 0 }" @click="changeTab(0)">
          <img src="@/assets/images/pay/wxPay.png" alt="" class="box80" />
          <div class="margin-top-sm">微信支付</div>
        </div>
        <div class="abox" :class="{ active: activeIndex === 1 }" @click="changeTab(1)">
          <img src="@/assets/images/pay/aliPay.png" alt="" class="box80" />
          <div class="margin-top-sm">支付宝支付</div>
        </div>
        <div class="abox" :class="{ active: activeIndex === 2 }" @click="changeTab(2)">
          <img src="@/assets/images/pay/tonglian.png" alt="" class="box80" />
          <div class="margin-top-sm">通联支付</div>
        </div>
      </div>
      <div class="margin-top">
        <div v-show="activeIndex === 0">
          <div class="text-bold margin-tb">微信支付</div>
          <a-row class="margin-bottom">
            <a-col :span="4"></a-col>
            <a-col :span="14">
              <a-radio-group v-model:value="atype" @change="(e) => onChangeType(e, 'wx')">
                <a-radio :value="1"> 普通 </a-radio>
                <a-radio :value="2"> 服务商 </a-radio>
              </a-radio-group>
              <a @click="isEditA = !isEditA" href="javascript:void(0)" class="text-green margin-right">
                <EditOutlined />{{ isEditA ? '编辑中' : '点击编辑' }}
              </a>
            </a-col>
          </a-row>
          <wx-pay :isEdit="isEditA" :type="atype"></wx-pay>
        </div>
        <div v-show="activeIndex === 1">
          <div class="text-bold margin-tb">支付宝支付</div>
          <a-row class="margin-bottom">
            <a-col :span="4"></a-col>
            <a-col :span="14">
              <a-radio-group v-model:value="btype" @change="(e) => onChangeType(e, 'ali')">
                <a-radio :value="1"> 普通 </a-radio>
                <a-radio :value="2"> 服务商 </a-radio>
              </a-radio-group>
              <a @click="isEditB = !isEditB" href="javascript:void(0)" class="text-green margin-right">
                <EditOutlined />{{ isEditB ? '编辑中' : '点击编辑' }}
              </a>
            </a-col>
          </a-row>
          <ali-pay :isEdit="isEditB" :type="btype"></ali-pay>
        </div>
        <div v-show="activeIndex === 2">
          <div class="text-bold margin-tb">通联支付</div>
        </div>
      </div>
    </a-card>
  </page-header-wrapper>
</template>

<script setup>
import { ref } from 'vue'
import { EditOutlined } from '@ant-design/icons-vue'
import wxPay from '../components/wxPay.vue'
import aliPay from '../components/aliPay.vue'

const activeIndex = ref(0)
const atype = ref(1)
const btype = ref(1)
const isEditA = ref(false)
const isEditB = ref(false)

function changeTab(index) {
  if (index === activeIndex.value) return
  activeIndex.value = index
  if (index === 0) {
    atype.value = 1
    isEditA.value = false
  } else if (index === 1) {
    btype.value = 1
    isEditB.value = false
  }
}

function onChangeType(e, type) {
  const val = e?.target?.value
  if (type === 'wx') {
    atype.value = val
  } else if (type === 'ali') {
    btype.value = val
  }
}
</script>

<style lang="less" scoped>
.abox {
  width: 120px;
  padding: 20px 0;
  text-align: center;
  cursor: pointer;
}
.abox.active {
  border: 1px solid rgb(54, 187, 54);
  border-radius: 5px;
}
.box80 {
  width: 50px;
  height: 50px;
}
</style>
